import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import cardTop from '../assets/imgs/dashboard/imgs/cardTop.png';
import coverImage from '../assets/imgs/dashboard/imgs/timelinecover1.png';
import ThemeToggler from '../components/ThemeToggler';
import img from '../assets/imgs/dashboard/imgs/img.jpg';
import dropFile from '../assets/imgs/dashboard/dropFile.png';
import QrCodeImg from '../assets/imgs/dashboard/QrCode.png';
import profile from '../assets/imgs/dashboard/profile.png';
class ProfileDetailV1 extends Component {
	state = {
		modals: {
			shareTimeline: false,
			inviteContributors: false,
			addMedia: false,
		},
	};
	toggleModal = name => {
		let { modals } = JSON.parse(JSON.stringify(this.state));
		for (let modal of Object.keys(modals)) {
			if (modal != name) modals[modal] = false;
		}

		modals[name] = !modals[name];
		this.setState({
			...this.state,
			modals,
		});
	};
	render() {
		return (
			<>
				<>
					<div className='profile-cover-image'>
						<img src={coverImage} style={{ width: '100%' }} />
						<div className='profile-image'>
							<img src={profile} />
						</div>
						<div className='profile-wrapper'>
							<div className='top-profile'>
								<div className='d-flex align-items-center'>
									<h3 className='d-none d-lg-block'>John</h3>
									<div className='ml-auto'>
										<ul>
											<li>
												<i className='fa fa-search'></i>
											</li>
											<li
												style={{ cursor: 'pointer' }}
												onClick={e => {
													e.preventDefault();
													this.toggleModal(
														'shareTimeline'
													);
												}}
											>
												<i className='fa fa-share'></i>
											</li>
											<li>
												<i className='fa fa-bell'></i>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className='bottom-profile '>
								<div className='d-flex align-items-end'>
									<div className='content-left d-none d-lg-block'>
										<h3>London-UK</h3>
										<h3>04/05/1990 - 02/01/2020</h3>
										<h6 className='m-0 timeline-text'>
											Lorem Ipsum is simply dummy text of
											the printing and typesetting
											industry. Lorem Ipsum has been the
											industry's standard dummy text ever
											since the 1500s, when an unknown
											printer took a galley of type and
											scrambled it to make a type specimen
											book. It has survived not only five
											centuries, but also the leap into
											electronic
										</h6>
									</div>
									<div className='content-right d-none d-md-flex ml-auto ml-lg-3'>
										<div className='qr-code'>
											<img src={QrCodeImg} />
										</div>
										<div className='btns'>
											<button className='btn btn-primary'>
												Generate QR Code
											</button>
											<button className='btn btn-primary'>
												Order QR Code
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className='btns-grp d-none d-lg-flex'>
								<div className='ml-auto'>
									<button
										className='btn btn-secondary'
										onClick={e => {
											e.preventDefault();
											this.toggleModal(
												'inviteContributors'
											);
										}}
									>
										Invite Collaboartives
									</button>
									<button className='btn btn-secondary'>
										Private Timeline
									</button>
									<button className='btn btn-secondary'>
										Generate QR code
									</button>
								</div>
							</div>
						</div>
					</div>
					<div className='profile-collaborates align-items-center'>
						<h3>Collaborators</h3>

						<div className='collaborators-wrapper'>
							<div
								className='collaborators px-4 d-flex w-100'
								style={{ justifyContent: 'space-between' }}
							>
								<div className='collaborator d-flex flex-column align-items-center'>
									<div className='img'>
										<img src={profile} />
									</div>
									Andy H.
								</div>
								<div className='collaborator d-flex flex-column align-items-center'>
									<div className='img'>
										<img src={profile} />
									</div>
									Simon W
								</div>
								<div className='collaborator d-flex flex-column align-items-center'>
									<div className='img'>
										<img src={profile} />
									</div>
									Elizabeth W.
								</div>
								<div className='collaborator d-flex flex-column align-items-center'>
									<div className='img'>
										<img src={profile} />
									</div>
									Julia
								</div>
								<div className='collaborator d-flex flex-column align-items-center'>
									<div className='img'>
										<img src={profile} />
									</div>
									Sandra
								</div>
							</div>
						</div>
						<ThemeToggler />
					</div>
					<div className='container'>
						<div
							className='info d-block d-lg-none'
							style={{ marginTop: 85 }}
						>
							<h5>John</h5>
							<h5>London-UK</h5>
							<h6>04/05/1990 - 02/01/2020</h6>
							<small>
								Lorem Ipsum is simply dummy text of the printing
								and typesetting industry. Lorem Ipsum has been
								the industry's standard dummy text ever since
								the 1500s, when an unknown printer took a galley
								of type and scrambled it to make a type specimen
								book. It has survived not only five centuries,
								but also the leap into electronic
							</small>
						</div>
						<div className='btns-grp d-block d-lg-none'>
							<div className='ml-auto'>
								<button
									className='btn btn-secondary'
									onClick={e => {
										e.preventDefault();
										this.toggleModal('inviteContributors');
									}}
								>
									Invite Collaboartives
								</button>
								<button className='btn btn-secondary'>
									Private Timeline
								</button>
								<button className='btn btn-secondary'>
									Generate QR code
								</button>
							</div>
						</div>
						<div className='d-flex mt-3 align-items-center d-md-none ml-auto ml-lg-3'>
							<div className='qr-code'>
								<img src={QrCodeImg} />
							</div>
							<div className='btns ml-3 d-flex flex-column'>
								<button className='btn btn-primary'>
									Generate QR Code
								</button>
								<button className=' mt-3 btn btn-primary'>
									Order QR Code
								</button>
							</div>
						</div>
					</div>

					<div className='container mt-5 mb-5 profile-cards'>
						<div className='row'>
							{new Array(11).fill(1).map(_ => (
								<div className='col-xl-3 col-lg-4 col-md-6 mb-3'>
									<div className='_16-9'>
										<img src={cardTop} />
									</div>
								</div>
							))}
							<div
								className='col-xl-3 col-lg-4 col-md-6 mb-3 pointer'
								onClick={e => this.toggleModal('addMedia')}
							>
								<div className='add-new'>
									<i className='fa fa-plus f28'></i>
									<span className='mt-3'>
										Add Photos or Videos
									</span>
								</div>
							</div>
						</div>
						<div className='d-flex justify-content-center mt-3'>
							<button className='btn btn-primary f14 px-4'>
								<i className='fa fa-plus mr-2'></i>Start your
								timeline
							</button>
						</div>
					</div>
				</>
				<Modal
					isOpen={this.state.modals.shareTimeline}
					size='md'
					centered
					className='custom-modal'
					toggle={e => this.toggleModal('shareTimeline')}
				>
					<ModalBody>
						<div className='d-flex'>
							<div
								className='custom-close-icon ml-auto'
								onClick={e => this.toggleModal('shareTimeline')}
							>
								<i className='fa fa-times'></i>
							</div>
						</div>
						<div className='modal-content-wrapper pt-0'>
							<h4 className='text-center font-weight-bold'>
								Share Timeline
							</h4>
							<div className='social-btns mt-5'>
								<button className='facebook'>
									Share to Facebook
									<i
										className='position-absolute  fa fa-facebook'
										style={{
											left: 15,
											top: '50%',
											transform: 'translateY(-50%)',
										}}
									></i>
								</button>
								<button className='twitter'>
									Share to Twitter
									<i
										className='position-absolute  fa fa-twitter'
										style={{
											left: 15,
											top: '50%',
											transform: 'translateY(-50%)',
										}}
									></i>
								</button>
								<button className='linkedin'>
									Share to LinkedIn
									<i
										className='position-absolute  fa fa-linkedin-square'
										style={{
											left: 15,
											top: '50%',
											transform: 'translateY(-50%)',
										}}
									></i>
								</button>
								<button className='copy'>
									Copy Link
									<i
										className='position-absolute  fa fa-play'
										style={{
											left: 15,
											top: '50%',
											transform: 'translateY(-50%)',
										}}
									></i>
								</button>
							</div>
						</div>
					</ModalBody>
				</Modal>
				<Modal
					isOpen={this.state.modals.addMedia}
					size='lg'
					centered
					className='custom-modal'
					toggle={e => this.toggleModal('addMedia')}
				>
					<ModalBody>
						<div className='modal-content-wrapper'>
							<h5 className='font-weight-bold'>Add to your memoir</h5>
							<h6 className='mt-5'>Media</h6>
							<div className='drag-drop px-5'>
								<div className='d-flex flex-column align-items-center justify-content-center'>
									<img
										src={dropFile}
										className='mb-2'
										style={{ width: '60px' }}
									/>
									<small className='d-flex'>
										Drag & Drop
										<br />
										or
										<br />
										Browse File
									</small>
								</div>
							</div>

							<h6 className='mt-5'>Description</h6>
							<textarea rows={5} className='form-control' />
							<div className='d-flex mt-4 justify-content-center'>
								<button className='btn btn-primary f14 mr-3'>
									Create
								</button>
								<button
									className='btn btn-primary-outline f14 dashboard-btn'
									onClick={e => this.toggleModal('addMedia')}
								>
									Cancel
								</button>
							</div>
						</div>
					</ModalBody>
				</Modal>

				<Modal
					isOpen={this.state.modals.inviteContributors}
					size='xl'
					centered
					className='custom-modal'
					toggle={e => this.toggleModal('inviteContributors')}
				>
					<ModalBody>
						<div className='modal-content-wrapper '>
							<h4 className='font-weight-bold'>
								Inviting contributors to add memories
							</h4>
							<p>
								Share this unique link with up to thirty people
								to give them access to contribute memories.
							</p>
							<div className='d-flex align-items-center'>
								<div
									className='timeline-card mr-4 d-none d-lg-block'
									style={{ width: 202, opacity: 0.6 }}
								>
									<div className='timeline-card-header'>
										<h6 className='m-0'>Timeline</h6>
									</div>
									<div className='timeline-card-body'>
										<div className='_16-9'>
											<img src={img} />
										</div>
									</div>
									<div className='pb-5'></div>
								</div>
								<div
									className='timeline-card'
									style={{ width: 270 }}
								>
									<div className='timeline-card-header'>
										<h5 className='m-0'>Timeline</h5>
										<span className='ml-auto'>
											<i className='fa fa-check' />
										</span>
									</div>
									<div className='timeline-card-body'>
										<div className='_16-9'>
											<img src={img} />
										</div>
									</div>
									<div className='timeline-card-footer'>
										<p className='m-0'>Date Created</p>
										<p className='m-0'>02/12/2020</p>
									</div>
								</div>
								<div
									className='timeline-card  ml-4 d-none d-lg-block'
									style={{ width: 202, opacity: 0.6 }}
								>
									<div className='timeline-card-header'>
										<h6 className='m-0'>Timeline</h6>
									</div>
									<div className='timeline-card-body'>
										<div className='_16-9'>
											<img src={img} />
										</div>
									</div>
									<div className='pb-5'></div>
								</div>
							</div>
							<div className='row mt-4'>
								<div className='col-md-8'>
									<label>
										Or Search existing Memories users
									</label>
									<input
										className='form-control'
										placeholder='Search here...'
									></input>
								</div>
							</div>
							<div className='access-level mt-3'>
								<label>Select their access level</label>
								<div className='d-flex radio-group'>
									<div className='d-flex radio align-items-center'>
										<input type='radio' />
										<span className='ml-2'>Admin</span>
									</div>
									<div className='ml-5 d-flex radio align-items-center'>
										<input type='radio' />
										<span className='ml-2'>
											Contributer
										</span>
									</div>
								</div>
							</div>
							<div className='row mt-4'>
								<div className='col-md-8'>
									<div className='row'>
										<div className='col-md-6'>
											<button className='btn btn-dark d-block w-100'>
												Add
											</button>
										</div>
										<div className='col-md-6 mt-3 mt-md-0'>
											<button
												className='btn btn-primary-outline d-block w-100 dashboard-btn'
												toggle={e =>
													this.toggleModal(
														'inviteContributors'
													)
												}
											>
												Cancel
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ModalBody>
				</Modal>
			</>
		);
	}
}

export default ProfileDetailV1;
